"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThreeLiner = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var clsx_1 = __importDefault(require("clsx"));
var useStyles = core_1.makeStyles(function (theme) {
    return core_1.createStyles({
        root: {
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'center',
            transition: function (props) {
                return theme.transitions.create(['all'], {
                    duration: props.animationDuration || theme.transitions.duration.standard,
                    easing: theme.transitions.easing.easeInOut,
                });
            },
        },
        title: {
            fontSize: '1.875rem',
            transition: function (props) {
                return theme.transitions.create(['all'], {
                    duration: props.animationDuration || theme.transitions.duration.standard,
                    easing: theme.transitions.easing.easeInOut,
                });
            },
        },
        subtitle: {
            fontSize: '1rem',
            transition: function (props) {
                return theme.transitions.create(['all'], {
                    duration: props.animationDuration || theme.transitions.duration.standard,
                    easing: theme.transitions.easing.easeInOut,
                });
            },
        },
        info: {
            fontSize: '0.875rem',
            transition: function (props) {
                return theme.transitions.create(['all'], {
                    duration: props.animationDuration || theme.transitions.duration.standard,
                    easing: theme.transitions.easing.easeInOut,
                });
            },
            fontWeight: 300,
        },
    });
});
var ThreeLinerRenderer = function (props, ref) {
    var title = props.title, subtitle = props.subtitle, info = props.info, _a = props.classes, classes = _a === void 0 ? {} : _a, className = props.className, 
    // ignore unused vars so that we can do prop transferring to the root element
    /* eslint-disable @typescript-eslint/no-unused-vars */
    animationDuration = props.animationDuration, otherDivProps = __rest(props, ["title", "subtitle", "info", "classes", "className", "animationDuration"]);
    var defaultClasses = useStyles(props);
    //const animationDuration = durationProp || theme.transitions.duration.standard;
    return (react_1.default.createElement("div", __assign({ ref: ref }, otherDivProps, { className: clsx_1.default(defaultClasses.root, classes.root, className) }),
        react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.title, classes.title) }, title),
        react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.subtitle, classes.subtitle) }, subtitle),
        react_1.default.createElement("div", { className: clsx_1.default(defaultClasses.info, classes.info) }, info)));
};
/**
 * [ThreeLiner](https://pxblue-components.github.io/react/?path=/info/components-three-liner--get-read-me-story) component
 *
 * The `ThreeLiner` can display up to three lines of stylized text or other custom content. It is most commonly used within the context of a [`AppBar`](./AppBar.md) component where the text can grow / shrink as the App Bar is expanded and collapsed.
 */
exports.ThreeLiner = react_1.default.forwardRef(ThreeLinerRenderer);
exports.ThreeLiner.displayName = 'ThreeLiner';
